var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',{attrs:{"href":"#close","aria-label":_vm.$t('Close'),"aria-hidden":"true"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }